import * as Sentry from '@sentry/react'
import { isChunkLoadError } from './lazyWithRetry'

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: __COMMIT_HASH__,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    beforeSend(event, hint) {
      const error = hint?.originalException
      if (isChunkLoadError(error)) return null

      const message = event.exception?.values?.[0]?.value || ''
      if (message.includes('WebGL context lost')) return null
      if (message.includes('ResizeObserver loop')) return null
      return event
    },
    maxBreadcrumbs: 50,
  })
}
